/**
 * Bidirectional sync of the two product title surfaces (MINSKY-15913):
 * 1. Top page / breadcrumb report title — useReportStore.title
 * 2. In-editor Document Title — Y.Map("documentMeta").title
 *
 * Same-value writes are no-ops so A→B→A cannot loop or fight collab.
 */

import {useReportStore} from '../features/products/useReportStore';

export const TITLE_SYNC_ORIGIN = 'title-sync';
export const TITLE_FIELD_ORIGIN = 'title-update';

export function normalizeReportTitle(value) {
    if (value == null) {
        return '';
    }
    return String(value);
}

export function titlesEqual(a, b) {
    return normalizeReportTitle(a) === normalizeReportTitle(b);
}

/**
 * Write documentMeta.title when it differs from `title`.
 * @returns {boolean} whether a Yjs write ran
 */
export function applyTitleToYDocMeta(ydoc, yDocMeta, title, origin = TITLE_SYNC_ORIGIN) {
    if (!ydoc || !yDocMeta) {
        return false;
    }
    const next = normalizeReportTitle(title);
    if (titlesEqual(yDocMeta.get('title'), next)) {
        return false;
    }
    ydoc.transact(() => {
        yDocMeta.set('title', next);
    }, origin);
    return true;
}

/**
 * Write useReportStore.title when it differs from `title`.
 * @returns {boolean} whether the store was updated
 */
export function applyTitleToReportStore(title) {
    const store = useReportStore.getState?.();
    if (!store || typeof store.updateReport !== 'function') {
        return false;
    }
    const next = normalizeReportTitle(title);
    if (titlesEqual(store.title, next)) {
        return false;
    }
    store.updateReport({title: next});
    return true;
}
